import { Box, Stack, Typography } from "@mui/material";

import { S } from "../reduction-analysis.styles";

export type ChartLegendSeries = {
    id: string;
    label?: string;
    description?: string;
    color: string;
};

type Props = {
    series: ChartLegendSeries[];
};

export const ChartLegend = (props: Props) => {
    const { series } = props;

    return (
        <Stack
            spacing={2}
            gap={(theme) => theme.spacing(2, 4)}
            direction="row"
            flexWrap="wrap"
            justifyContent="center"
            sx={{ maxWidth: "90%", margin: "auto", mb: 4 }}
        >
            {series.map(
                (serie) =>
                    serie.label && (
                        <S.Tooltip
                            title={
                                serie.description && (
                                    <>
                                        <Typography
                                            variant="h5"
                                            fontWeight="bold"
                                            color="primary"
                                        >
                                            {serie.label}
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            {serie.description}
                                        </Typography>
                                    </>
                                )
                            }
                            key={serie.id}
                        >
                            <Box>
                                <S.TooltipCircle htmlColor={serie.color} />
                                <Typography
                                    variant="body2"
                                    display="inline"
                                    sx={{
                                        textDecoration: serie.description
                                            ? "underline"
                                            : "none",
                                    }}
                                >
                                    {serie.label}
                                </Typography>
                            </Box>
                        </S.Tooltip>
                    )
            )}
        </Stack>
    );
};
